import { NumericFormat } from "react-number-format";
import { useState } from "react";

export const InputCurrency = ({
	name,
	label,
	formData,
	setFormData,
	placeholder,
	disabled,
	required = false,
	error = null,
}) => {
	const [touched, setTouched] = useState(false);
	// 🔹 Función para manejar el cambio
	const handleValueChange = (values) => {
		const { floatValue } = values; // Obtiene el valor numérico sin el formato
		setFormData((prev) => ({ ...prev, [name]: floatValue }));
	};

	const value = formData[name];
	const internalError =
		required && touched && (!value || Number(value) <= 0) && !error
			? "Este campo es requerido"
			: null;
	const mergedError = error || internalError;

	return (
		<div>
			<label
				htmlFor={name}
				className="block text-md font-semibold text-gray-900 leading-6 ml-1"
			>
				{label}
				{required && (
					<span className="text-red-500 ml-1" aria-hidden="true">
						*
					</span>
				)}
			</label>
			<div className="mt-3">
				<NumericFormat
					value={value || ""}
					thousandSeparator=","
					decimalSeparator="."
					decimalScale={2}
					fixedDecimalScale
					prefix="$ "
					onValueChange={handleValueChange}
					placeholder={placeholder || "$ 0.00"}
					disabled={disabled}
					onBlur={() => setTouched(true)}
					aria-required={required}
					aria-invalid={mergedError ? true : undefined}
					className={`block w-full rounded-md border-0 py-2 px-4 text-gray-900 shadow-sm ring-1 ring-inset sm:text-sm sm:leading-6 ${
						mergedError
							? "ring-red-500 placeholder:text-red-400 focus:ring-2 focus:ring-inset focus:ring-red-500"
							: "ring-gray-300 placeholder:text-gray-400 focus:bg-indigo-50 focus:ring-2 focus:ring-inset focus:ring-indigo-600"
					}`}
				/>
			</div>
			{mergedError && (
				<p className="mt-2 text-sm text-red-600 flex items-center gap-1 ml-1">
					<svg className="w-4 h-4 shrink-0" fill="currentColor" viewBox="0 0 20 20">
						<path
							fillRule="evenodd"
							d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
							clipRule="evenodd"
						/>
					</svg>
					{mergedError}
				</p>
			)}
		</div>
	);
};
